// SABERA: オンラインストア 本体購入ページ (sections/main-store-body.liquid)
// レンズ/オプション選択に応じた画面表示上の見積り計算、条件付き必須項目の切替、
// 送信前の度数バリデーションと、本体・レンズ・オプション商品の一括カート追加を行う。
document.querySelectorAll('.store-body__form').forEach((form) => {
  const rangeDialog = form.querySelector('[data-store-body-range-dialog]');
  const rangeOpen = form.querySelector('[data-store-body-range-open]');
  const rangeClose = form.querySelector('[data-store-body-range-close]');
  rangeOpen?.addEventListener('click', () => {
    if (!rangeDialog) return;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.setProperty('--store-body-scrollbar-compensation', `${scrollbarWidth}px`);
    document.body.classList.add('store-body-range-open');
    rangeDialog.showModal();
    rangeDialog.focus({ preventScroll: true });
  });
  rangeClose?.addEventListener('click', () => rangeDialog?.close());
  rangeDialog?.addEventListener('click', (event) => {
    if (event.target !== rangeDialog) return;
    const rect = rangeDialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
      rangeDialog.close();
    }
  });
  rangeDialog?.addEventListener('close', () => {
    document.body.classList.remove('store-body-range-open');
    document.body.style.removeProperty('--store-body-scrollbar-compensation');
    rangeOpen?.focus({ preventScroll: true });
  });

  const lensToggle = form.querySelector('[data-store-body-lens-toggle]');
  const lensConfig = form.querySelector('[data-store-body-lens-config]');
  const lensRow = form.querySelector('[data-store-body-lens-row]');
  const lensDetail = form.querySelector('[data-store-body-lens-detail]');
  const lensPriceEl = form.querySelector('[data-store-body-lens-price]');

  const optionToggle = form.querySelector('[data-store-body-option-toggle]');
  const optionRow = form.querySelector('[data-store-body-option-row]');
  const optionDetail = form.querySelector('[data-store-body-option-detail]');
  const optionPriceEl = form.querySelector('[data-store-body-option-price]');

  const totalEl = form.querySelector('[data-store-body-total]');
  const variantInput = form.querySelector('[data-store-body-variant-input]');
  const variantPriceEl = form.querySelector('[data-store-body-variant-price]');
  const variantLabelEl = form.querySelector('[data-store-body-variant-label]');
  const prescriptionError = form.querySelector('[data-store-body-prescription-error]');
  const prescriptionInputs = [...form.querySelectorAll('[data-store-body-prescription-value]')];
  const upload = form.querySelector('[data-store-body-upload]');
  const uploadInput = form.querySelector('[data-store-body-upload-input]');
  const uploadPrompt = form.querySelector('[data-store-body-upload-prompt]');
  const uploadSelected = form.querySelector('[data-store-body-upload-selected]');
  const uploadName = form.querySelector('[data-store-body-upload-name]');
  const uploadSize = form.querySelector('[data-store-body-upload-size]');
  const uploadThumbnail = form.querySelector('[data-store-body-upload-thumbnail]');
  const uploadRemove = form.querySelector('[data-store-body-upload-remove]');
  const uploadError = form.querySelector('[data-store-body-upload-error]');
  const submitButtons = form.querySelectorAll('.store-body__submit, [data-store-body-sticky-submit]');
  const submitError = form.querySelector('[data-store-body-submit-error]');
  const maxUploadSize = 20 * 1024 * 1024;
  const allowedUploadTypes = ['image/jpeg', 'image/png', 'image/heic', 'image/heif', 'application/pdf'];
  const allowedUploadExtensions = ['jpg', 'jpeg', 'png', 'heic', 'heif', 'pdf'];
  let uploadObjectUrl = '';
  let isSubmitting = false;

  const parsePrice = (text) => {
    if (!text) return 0;
    const num = parseFloat(String(text).replace(/,/g, ''));
    return Number.isFinite(num) ? num : 0;
  };
  const formatPrice = (num) => Math.round(num).toLocaleString('ja-JP');
  const selectedRadio = (fieldset) => fieldset?.querySelector('input[type="radio"]:checked:not(:disabled)') || null;

  const basePrice = parsePrice(totalEl?.textContent);

  const setUploadError = (message = '') => {
    upload?.classList.toggle('is-error', Boolean(message));
    if (uploadError) {
      uploadError.textContent = message;
      uploadError.hidden = !message;
    }
    uploadInput?.setAttribute('aria-invalid', message ? 'true' : 'false');
  };

  const clearUploadPreview = () => {
    if (uploadObjectUrl) URL.revokeObjectURL(uploadObjectUrl);
    uploadObjectUrl = '';
    upload?.classList.remove('is-selected');
    if (uploadPrompt) uploadPrompt.hidden = false;
    if (uploadSelected) uploadSelected.hidden = true;
    if (uploadRemove) uploadRemove.hidden = true;
    if (uploadThumbnail) {
      uploadThumbnail.style.removeProperty('background-image');
      uploadThumbnail.classList.remove('is-document');
    }
  };

  const validateUpload = ({ showRequired = false } = {}) => {
    const file = uploadInput?.files?.[0];
    let message = '';
    if (!file && showRequired && uploadInput?.required) {
      message = '※ファイルを選択してください。';
    } else if (
      file &&
      !allowedUploadTypes.includes(file.type.toLowerCase()) &&
      !allowedUploadExtensions.includes(file.name.split('.').pop()?.toLowerCase())
    ) {
      message = '※JPEG / PNG / HEIC / PDF形式のファイルを選択してください。';
    } else if (file && file.size > maxUploadSize) {
      message = '※ファイルサイズが20MBを超えています。';
    }
    uploadInput?.setCustomValidity(message);
    setUploadError(message);
    return !message;
  };

  const showUploadPreview = () => {
    clearUploadPreview();
    const file = uploadInput?.files?.[0];
    if (!file) return;
    upload?.classList.add('is-selected');
    if (uploadPrompt) uploadPrompt.hidden = true;
    if (uploadSelected) uploadSelected.hidden = false;
    if (uploadRemove) uploadRemove.hidden = false;
    if (uploadName) uploadName.textContent = file.name;
    if (uploadSize) uploadSize.textContent = `${(file.size / 1024 / 1024).toFixed(1)}MB`;
    if (uploadThumbnail) {
      if (file.type.startsWith('image/') && file.type !== 'image/heic') {
        uploadObjectUrl = URL.createObjectURL(file);
        uploadThumbnail.style.backgroundImage = `url("${uploadObjectUrl}")`;
      } else {
        uploadThumbnail.classList.add('is-document');
      }
    }
  };

  const validatePrescription = () => {
    const invalidInputs = new Set();
    for (const eye of ['右', '左']) {
      const sph = form.querySelector(`[name="properties[${eye}目 SPH]"]`);
      const cyl = form.querySelector(`[name="properties[${eye}目 CYL]"]`);
      const sphVal = sph ? parseFloat(sph.value) || 0 : 0;
      const cylVal = cyl ? parseFloat(cyl.value) || 0 : 0;
      if (Math.abs(sphVal) + Math.abs(cylVal) > 10) {
        invalidInputs.add(sph);
        invalidInputs.add(cyl);
      }
    }
    prescriptionInputs.forEach((input) => {
      const invalid = invalidInputs.has(input);
      input.closest('[data-sabera-stepper]')?.classList.toggle('is-error', invalid);
      input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    });
    if (prescriptionError) prescriptionError.hidden = invalidInputs.size === 0;
    return invalidInputs.size === 0;
  };

  const updateConditionalRequired = (lensOn) => {
    lensConfig?.querySelectorAll('input, select, textarea').forEach((el) => {
      el.disabled = !lensOn;
    });
    lensConfig?.querySelectorAll('[data-store-body-conditional-required]').forEach((el) => {
      el.required = lensOn;
    });
  };

  const syncSticky = () => {
    const sticky = form.querySelector('[data-store-body-sticky]');
    if (!sticky) return;
    sticky.querySelector('[data-sticky-total]').textContent = totalEl?.textContent || '';
    sticky.querySelector('[data-sticky-lens-price]').textContent = lensPriceEl?.textContent || '0';
    sticky.querySelector('[data-sticky-option-price]').textContent = optionPriceEl?.textContent || '0';
    sticky.querySelector('[data-sticky-lens-row]').hidden = !lensRow || lensRow.hidden;
    sticky.querySelector('[data-sticky-option-row]').hidden = !optionRow || optionRow.hidden;
  };

  const update = () => {
    const lensRadio = selectedRadio(lensToggle);
    const lensOn = !!lensRadio && lensRadio.value !== '補正なし';
    const lensTypeRadio = lensConfig?.querySelector('input[name="properties[レンズタイプ]"]:checked');
    const lensThicknessRadio = lensConfig?.querySelector('input[name="properties[レンズの薄さ]"]:checked');

    const productVariantId = lensOn
      ? lensThicknessRadio?.dataset.storeBodyProductVariantId
      : lensRadio?.dataset.storeBodyProductVariantId;
    if (variantInput && productVariantId) variantInput.value = productVariantId;
    if (variantInput && lensThicknessRadio?.dataset.storeBodyVariantId) {
      const variantPrice = parsePrice(lensThicknessRadio.dataset.storeBodyVariantPrice);
      variantInput.value = lensThicknessRadio.dataset.storeBodyVariantId;
      if (variantPriceEl) variantPriceEl.textContent = formatPrice(variantPrice);
      if (variantLabelEl) {
        variantLabelEl.textContent = `単焦点 / ${lensThicknessRadio.dataset.storeBodyVariantLabel || ''}`;
      }
      if (totalEl) totalEl.textContent = formatPrice(variantPrice);
      updateConditionalRequired(true);
      syncSticky();
      return;
    }

    let lensPrice = 0;
    if (lensOn) {
      lensPrice += parsePrice(lensRadio.dataset.price);
      if (lensThicknessRadio) lensPrice += parsePrice(lensThicknessRadio.dataset.price);
    }

    if (lensConfig) lensConfig.hidden = !lensOn;
    if (lensRow) lensRow.hidden = !lensOn;
    if (lensDetail) {
      const parts = [lensTypeRadio?.value, lensThicknessRadio?.value.split('(')[0]].filter(Boolean);
      lensDetail.textContent = parts.length ? ' ' + parts.join('/') : '';
    }
    if (lensPriceEl) lensPriceEl.textContent = formatPrice(lensPrice);
    updateConditionalRequired(lensOn);

    const optionRadio = selectedRadio(optionToggle);
    const optionOn = !!optionRadio && optionRadio.value !== 'なし';
    const optionPrice = optionOn ? parsePrice(optionRadio.dataset.price) : 0;
    if (optionRow) optionRow.hidden = !optionOn;
    if (optionDetail) optionDetail.textContent = optionOn ? ' クリップオン式サングラス' : '';
    if (optionPriceEl) optionPriceEl.textContent = formatPrice(optionPrice);

    if (totalEl) totalEl.textContent = formatPrice(basePrice + lensPrice + optionPrice);
    syncSticky();
  };

  form.addEventListener('change', update);
  prescriptionInputs.forEach((input) => {
    input.addEventListener('input', validatePrescription);
    input.addEventListener('change', validatePrescription);
  });
  uploadInput?.addEventListener('change', () => {
    if (validateUpload()) {
      showUploadPreview();
    } else {
      clearUploadPreview();
    }
  });
  uploadInput?.addEventListener('invalid', (event) => {
    event.preventDefault();
    validateUpload({ showRequired: true });
    upload?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  uploadRemove?.addEventListener('click', () => {
    if (uploadInput) uploadInput.value = '';
    uploadInput?.setCustomValidity('');
    clearUploadPreview();
    setUploadError('');
    uploadInput?.focus();
  });
  update();

  form.addEventListener('submit', async (event) => {
    if (isSubmitting) {
      event.preventDefault();
      return;
    }

    const lensRadio = selectedRadio(lensToggle);
    const lensOn = !!lensRadio && lensRadio.value !== '補正なし';

    if (lensOn) {
      const prescriptionIsValid = validatePrescription();
      const uploadIsValid = validateUpload({ showRequired: true });
      if (!prescriptionIsValid || !uploadIsValid) {
        event.preventDefault();
        const firstError = form.querySelector('.sabera-stepper.is-error, .store-body__upload-wrap.is-error');
        firstError?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }

    const optionRadio = selectedRadio(optionToggle);
    const optionVariantId = optionRadio?.value !== 'なし' ? optionRadio?.dataset.storeBodyAddonVariantId : '';
    const addonVariantIds = [optionVariantId].filter(Boolean);

    isSubmitting = true;
    if (submitError) {
      submitError.textContent = '';
      submitError.hidden = true;
    }
    submitButtons.forEach((submitButton) => {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    });

    // オプションなしの場合も送信ボタンをロックしたまま通常のフォーム送信を行う。
    if (addonVariantIds.length === 0) return;

    event.preventDefault();

    const cartData = new FormData();
    const sourceData = new FormData(form);
    const mainVariantId = sourceData.get('id');
    cartData.append('items[0][id]', mainVariantId);
    cartData.append('items[0][quantity]', '1');

    sourceData.forEach((value, name) => {
      const propertyMatch = name.match(/^properties\[(.+)]$/);
      if (propertyMatch && (typeof value !== 'string' || value !== '')) {
        cartData.append(`items[0][properties][${propertyMatch[1]}]`, value);
      }
    });

    addonVariantIds.forEach((variantId, index) => {
      const itemIndex = index + 1;
      cartData.append(`items[${itemIndex}][id]`, variantId);
      cartData.append(`items[${itemIndex}][quantity]`, '1');
      cartData.append(`items[${itemIndex}][properties][_セット商品]`, 'SABERAスマート眼鏡セット');
    });

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: cartData,
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'カートへの追加に失敗しました。');
      }
      window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch (error) {
      isSubmitting = false;
      if (submitError) {
        submitError.textContent = error.message || 'カートへの追加に失敗しました。時間をおいて再度お試しください。';
        submitError.hidden = false;
      }
      submitButtons.forEach((submitButton) => {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      });
    }
  });
});
